import { SOCIAL_AWARD_META, type SocialAward } from '../../domain/awards/types';
import { formatMonthKey } from '../../domain/leaderboard/types';
import './Awards.css';

export interface MonthRecapCardProps {
  monthKey: string;
  awards: SocialAward[];
  /** Takes the reader to the full board for that month. */
  onSeeAll: () => void;
}

function compactValue(award: SocialAward): string {
  const signed = award.type === 'most_improved' && award.value > 0 ? '+' : '';
  return award.unit === 'lb'
    ? `${award.value.toLocaleString()} lb`
    : `${signed}${award.value.toLocaleString()}`;
}

/**
 * The month's results, dropped into the feed at the head of that month.
 *
 * It posts itself where it belongs chronologically and then scrolls away into
 * history like everything else, which is why the feature needs no new
 * navigation of its own.
 */
export function MonthRecapCard({ monthKey, awards, onSeeAll }: MonthRecapCardProps) {
  if (awards.length === 0) return null;

  return (
    <section className="recap" aria-label={`${formatMonthKey(monthKey)} results`}>
      <div className="recap__top">
        <div className="recap__eyebrow">Results are in</div>
        <div className="recap__title">{formatMonthKey(monthKey)}</div>
      </div>

      {awards.map((award) => (
        <div className="recap__row" key={award.type}>
          <span className="recap__medal" aria-hidden="true">
            {SOCIAL_AWARD_META[award.type].icon}
          </span>
          <span className="recap__label">{SOCIAL_AWARD_META[award.type].short}</span>
          <span className="recap__who">{award.displayName}</span>
          <span className="recap__val">{compactValue(award)}</span>
        </div>
      ))}

      <button type="button" className="recap__all" onClick={onSeeAll}>
        See full results →
      </button>
    </section>
  );
}
